module.exports = __webpack_public_path__ + "static/media/material_preparacion.1189ab03.png";